import { SearchIcon } from 'components/icons';
import { InputGroup, InputGroupAddon, InputGroupInput } from 'components/ui/input-group';
import { cn } from 'utils/cn';

type Props = {
    /** Names the field for a screen reader. */
    label: string;
    placeholder: string;
    value: string;
    onChange: (value: string) => void;
    className?: string;
};

/** The search over a list of shared widgets that is already loaded. */
export function SearchField({ label, placeholder, value, onChange, className }: Props) {
    return (
        <InputGroup className={cn('border-border-control bg-card w-[280px] shadow-none', className)}>
            <InputGroupAddon>
                <SearchIcon />
            </InputGroupAddon>
            <InputGroupInput
                type="search"
                aria-label={label}
                placeholder={placeholder}
                value={value}
                onChange={(event) => onChange(event.target.value)}
            />
        </InputGroup>
    );
}
